@if (image) {
  <img class="fmnts-avatar-icon__image" [src]="image" />
} @else {
  <!-- Alternative content when there is no image -->
  <ng-content />
}
